import { createFileRoute, redirect } from "@tanstack/react-router";

// /book historically hosted the guest-application form, which caused a
// URL collision — visitors expecting the published book "Build, Don't Talk"
// landed on a guest-pitch form. The guest form now lives at /guest, and
// /book redirects to the actual book page.
export const Route = createFileRoute("/book")({
  beforeLoad: () => {
    throw redirect({ to: "/build-dont-talk", replace: true });
  },
  component: () => null,
});
